<script setup lang="ts">
import {
  ref,
  watch,
  type PropType
} from '#imports'

type Mode = 'hover' | 'fade';

defineProps({
  content: {
    type: String,
    required: true,
    default: ''
  },
  show: {
    type: Boolean,
    required: true,
    default: false
  },
  mode: {
    type: String as PropType<Mode>,
    required: false,
    default: 'hover',
    validator: (value: string) => ['hover', 'fade'].includes(value)
  },
  // fadeDuration: {
  //   type: Number,
  //   required: false,
  //   default: 3000 // 3 seconds in milliseconds
  // }
})


</script>

<template>
 <transition name="tooltip-fade">
   <div v-if="show" class="tooltip"><small>{{ content }}</small></div>
 </transition>
</template>

<style lang="postcss" scoped>
.tooltip {
  position: absolute;
  background-color: var(--color-gray-500);
  color: var(--color-white);
  border-radius: 4px;
  padding: 0.1rem 0.5rem;
  display: flex;
  place-items: center;
  z-index: 1000;
  width: fit-content;
  white-space: nowrap;
}

.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.3s ease;
}

.tooltip-fade-enter-from,
.tooltip-fade-leave-to {
  opacity: 0;
}

.tooltip-fade-enter-to,
.tooltip-fade-leave-from {
  opacity: 1;
}

</style>
